module.exports = __webpack_public_path__ + "img/headline.ea1e52c.svg";